module.exports = __webpack_public_path__ + "img/he-arc-ingenierie-bachelor-conception-ergonomique-et-design-300x186.2f7a087f.jpg";